import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, A11y, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default function FeatureCarousel({ slides = [] }) {
  const prefersReduced =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  return (
    <section role="region" aria-label="Feature highlights carousel" className="flex items-center justify-center">
      <Swiper
        modules={[Autoplay, Pagination, A11y, EffectFade]}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        autoplay={
          prefersReduced
            ? false
            : { delay: 3500, pauseOnMouseEnter: true, disableOnInteraction: false }
        }
        pagination={{ clickable: true }}
        loop
        className="w-full h-full max-w-xl"
      >
        {slides.map((s, i) => (
          <SwiperSlide key={i}>
            <div className="flex h-full flex-col items-center justify-center text-center space-y-4 sm:space-y-6">
              <div className="w-full">
                <div className="mx-auto w-72 h-44 sm:w-80 sm:h-56 md:w-[22rem] md:h-60 bg-slate-50 dark:bg-slate-700 rounded-2xl ring-1 ring-slate-200 dark:ring-slate-600 shadow-md flex items-center justify-center overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.currentTarget.src = "https://via.placeholder.com/640x360?text=Image+Not+Found";
                    }}
                  />
                </div>
              </div>

              <h2 className="text-base sm:text-lg font-semibold text-slate-900 dark:text-slate-100">{s.title}</h2>
              <p className="text-slate-600 dark:text-slate-400 text-sm sm:text-base max-w-md">{s.caption}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
